/**
 * Shared Socket.IO client — one connection per tab, ref-counted.
 *
 * The path MUST match the backend's `socketio_path` (`/api/socket.io`) so
 * the ingress routes the handshake to the backend without extra rules.
 */
import { io } from 'socket.io-client';

let socket = null;
let refCount = 0;

const origin = () => (process.env.REACT_APP_BACKEND_URL || window.location.origin).replace(/\/$/, '');

export function acquireSocket() {
  if (socket) { refCount += 1; return socket; }
  socket = io(origin(), {
    path: '/api/socket.io',
    transports: ['polling', 'websocket'],
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 15000,
    timeout: 20000,
  });
  refCount = 1;
  return socket;
}

export function releaseSocket() {
  refCount = Math.max(0, refCount - 1);
  if (refCount === 0 && socket) {
    try { socket.disconnect(); } catch (_) { /* noop */ }
    socket = null;
  }
}
